<template>
  <div>
    <el-col class="search-list">
      <el-col :span="2" class="flex-algin-start search-label">
        <el-col class="flex-center">
          <span class="font-13">{{listData.title}}</span>
        </el-col>
      </el-col>
      <el-col :span="18">
        <div>
          <ul class="search-item clear">
            <li
              v-for="(item,index) in listData.list"
              :key="index"
              :class="{'search-item-active':itemActive[index]}"
              @click="getActive(item,index)"
              @mouseover="searchHover(index,true)"
              @mouseleave="searchHover(index,false)"
              ref="searchStyle"
            >
              <el-checkbox-group v-model="checked" v-if="!checkShow">
                <el-checkbox
                  :label="item.value?item.value:item.hotelBrandName"
                >{{item.label?item.label:item.hotelBrandName}}</el-checkbox>
              </el-checkbox-group>
              <span v-show="checkShow">{{item.label?item.label:item.hotelBrandName}}</span>
            </li>
          </ul>
          <div class="flex-center search-item-btn" v-show="!checkShow">
            <span @click="submitCheck">确定</span>
            <span @click="cancel">取消</span>
          </div>
        </div>
      </el-col>
      <el-col :span="4" class="flex-algin-start search-label">
        <el-col class="flex-end">
          <span @click="addMore('more')" class="cursor more-btn" v-if="listData.statu">
            {{moreStatu.text}}
            <i :class="moreStatu.ico"></i>
          </span>
          <!-- <span class="search-addmore cursor" @click="addMore('multiple')" v-if="listData.moreStatu">多选 <i class="el-icon-plus"></i></span> -->
        </el-col>
      </el-col>
    </el-col>
  </div>
</template>
<script>
export default {
  data() {
    return {
      listShow: false,
      checked: [], //选择器
      itemActive: [true],
      checkShow: true, //多选控制
      moreStatu: {
        text: "更多",
        ico: "el-icon-arrow-down",
        statu: true
      },
      fristList: [], //酒店显示列表
      show: true,
      saveClickItem: {}
    };
  },
  props: {
    listData: {
      type: Object,
      default: {}
    },
    star: {
      type: Number,
      default: 0
    },
    showList: {
      type: Array,
      default: []
    }
  },
  created() {
    if (this.star) {
      this.itemActive = [];
      this.itemActive[this.star] = true;
    }
  },
  watch: {
    showList(val) {
      let list = this.listData.allList || this.listData.list;
      if (val.length === 0) {
        this.itemActive = [];
        this.$set(this.itemActive, 0, true);
        return;
      }
      this.itemActive = [];
      list.map((item, index) => {
        val.map(sitem => {
          if (sitem == item) {
            this.$set(this.itemActive, index, true);
          }
        });
      });
    }
  },
  methods: {
    //点击更多
    addMore(val) {
      let statu = this.moreStatu;
      let list = this.listData;
      if (val == "multiple") {
        this.checkShow = !this.checkShow;
        this.itemActive = null;
        if (this.checkShow) {
          this.cancel();
        }
        this.checked = [];
        //    this.checkShow?list.list = this.allList:list.list = this.fristList
      } else {
        statu.statu = !statu.statu;
        if (this.show) {
          this.fristList = this.listData.list;
          this.show = false;
        }
        statu.statu
          ? ((statu.text = "更多"),
            (statu.ico = "el-icon-arrow-down"),
            (list.list = this.fristList))
          : ((statu.text = "收起"),
            (statu.ico = "el-icon-arrow-up"),
            (list.list = list.allList));
      }
    },
    cancel() {
      this.checkShow = true;
      this.itemActive = 0;
      let data = {
        type: this.listData.type,
        value: this.listData.list[0]
      };
      this.$emit("clickItem", data);
    },
    //点击子选项
    getActive(item, index) {
      // if(!this.itemActive&&this.checkShow == false)return
      // this.itemActive[index] = true
      let val = item.value || item.hotelBrandId;
      let data = {
        type: this.listData.type,
        value: item
      };
      if (!val) {
        this.itemActive = [true];
        this.$emit("clickItem", data);
        return;
      }
      this.itemActive[0] = false;
      this.$set(this.itemActive, index, true);
      // console.log(this.itemActive)
      this.saveClickItem = item;
      this.$forceUpdate();
      this.$emit("clickItem", data);
    },
    //点击效果
    searchHover(index, statu) {
      let item = this.$refs.searchStyle;
      if (!this.checkShow) return;
      if (statu) {
        item[index].style.background = "#237dc8";
        item[index].style.color = "white";
      } else {
        item[index].style.background = "";
        item[index].style.color = "";
      }
    },
    submitCheck() {
      let data = {
        type: this.listData.type,
        value: this.checked
      };
      this.$emit("clickItemMore", data);
    }
  }
};
</script>
<style lang="less" scoped>
.search-list {
  display: flex;
  font-size: 12px;
  .search-item {
    list-style: none;
    width: 100%;
    // height: 100%;
    margin: 5px 0;
    li {
      float: left;
      min-width: 10%;
      text-align: left;
      overflow: hidden;
      margin: 2px 3px;
      width: 88px;
      height: 25px;
      line-height: 25px;
      padding-left: 4px;
      //    padding: 3px 10px;
      cursor: pointer;
    }
    li:first-child {
      //    width:40px !important;
      //    text-align: center;
    }
  }
  .search-item-btn {
    margin: 20px 0 0 0;
    span {
      padding: 2px 8px;
      border: 1px solid #ccc;
      margin: 0 5px;
      cursor: pointer;
      &:hover {
        background: #237dc8;
        border-color: #237dc8;
        color: white;
      }
    }
  }
  .search-addmore {
    border: 1px solid #999;
    padding: 2px 5px;
    margin-left: 10px;
  }
  .search-label {
    padding: 8px 0;
    .more-btn {
      border: 1px solid #999;
      padding: 2px 5px;
    }
  }
}
.search-list {
  border-top: 1px solid #f1f1f1;
}
.search-item-active {
  overflow: hidden;
  border: 1px solid #237dc8;
  //  background: #237dc8;
  color: #237dc8;
}
</style>
